import getMrsConnectedAccountsOperation from 'owa-service/lib/operation/getMrsConnectedAccountsOperation';
import GetMrsConnectedAccountsRequest from 'owa-service/lib/contract/GetMrsConnectedAccountsRequest';
import GetMrsConnectedAccountsResponse from 'owa-service/lib/contract/GetMrsConnectedAccountsResponse';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function getMrsConnectedAccounts(): Promise<GetMrsConnectedAccountsResponse> {
    let request: GetMrsConnectedAccountsRequest = {
        Header: getJsonRequestHeader(),
        RequestWorkloadType: 'SyncAggregation',
        SyncProtocols: ['Imap', 'Pop', 'Unified'],
    };

    let response: GetMrsConnectedAccountsResponse = await getMrsConnectedAccountsOperation(request);
    return response;
}
